<script lang="ts">
    import { imask } from '@imask/svelte';
    import debounce from 'lodash/debounce';
    import InputWrapper from './InputWrapper.svelte';
    import cx from 'classnames';

    export let id: string;
    export let label: string;
    export let helperText: string = '';
    export let value: number = null;
    export let suffix: | 'km' | '%' | 'měsíců' | 'Kč' | null = null;
    export let precision: number = 0;
    export let thousandsSeparator: string = ' ';
    export let customClass: string = '';
    export let inline: boolean = false;
    export let allowEmpty: boolean = false;

    let displayValue = value ? value.toString() : '0';

    $: isValid = allowEmpty || Boolean(value);

    const options = {
        mask: suffix ? `num ${suffix}` : 'num',
        lazy: false,
        blocks: {
            num: {
                mask: Number,
                scale: precision,
                thousandsSeparator,
            }
        }
    };

    const accept = ({ detail: maskRef }) => {
        displayValue = maskRef.value;
    }

    const complete = ({ detail: maskRef }) => {
        value = Number(maskRef.unmaskedValue);
    }

    const mousedown = (event) => {
        const el = event.currentTarget;
        if(document.activeElement !== el) {
            setTimeout(() => {
                el.select();    
            }, 0);
        }
    }

    const debouncedComplete = debounce(complete, 500);
</script>

<InputWrapper id={id} label={label} helperText={helperText} inline={inline} customClass={customClass}>
    <input
        id={id}
        class={cx('form-control', {'is-invalid': !isValid})}
        value={displayValue}
        use:imask={options}
        on:accept={accept}
        on:complete={debouncedComplete}
        on:mousedown={mousedown}
    />
    <div class="invalid-feedback">
        Prosím, vyplňte.
    </div>
</InputWrapper>